import React, {Component} from 'react';
import {request} from "../../helper/APIUtils";

class UnReadCount extends Component {
    constructor(props) {
        super(props);
        this.state = {
            count: 0
        }
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData() {
        let params = {
            url: '/requestForm/getUnReadMessageCount?requestId=' + this.props.requestId,
            method: "get"
        };
        request(params).then(response => {
            this.setState({count: response.data});
        })
    }

    render() {
        return (
            <div>
                {this.state.count !== 0 &&
                <div id="unread">
                    <i className="fas fa-envelope envelope"></i>
                    <span className="badge badge-danger">{this.state.count}</span>
                </div>
                }
            </div>
        );
    }

}

export default UnReadCount;